import { Suspense, lazy } from 'react';

import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

const Chat = lazy(() =>
  import('./Chat').then((module) => ({ default: module.Chat }))
);

export const chatRoutes: RouteObject[] = [
  {
    index: true,
    element: (
      <Suspense fallback={<LoadingIndicator />}>
        <Chat />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/chat" linkText="Go back to chat" />
    ),
  },
];
